import {Feature} from '../core/model/feature.js';

/**
 * Sexicon feature has no template a.t.m. but it's existence is checked in
 * [../core/widgets/overlayReason.js]
 */
export const sexiconFeature = new Feature('sexicon');
